import { Grid } from "@mui/material";

import React from "react";
import TaxpayerDetails from "./TaxpayerDetails";

const EnterALookupDetails = () => {
  return (
    <Grid size={{ xs: 12 }}>
      <TaxpayerDetails />

      {/* <Card>
        <CardContent>
          <AssessmentSwitch />
        </CardContent>
      </Card> */}
    </Grid>
  );
};

export default EnterALookupDetails;
